import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";

import { Option } from "@shared/Entities/General/option.entity";

import { NewUser } from "../../Types/new-user";

@Component({
  selector: "app-confirmation",
  templateUrl: "./confirmation.component.html",
})
export class ConfirmationComponent implements OnChanges {
  @Input() public newUser: NewUser | null;
  @Input() public isEditing: boolean = false;
  @Output() public reset = new EventEmitter<void>();
  public roles: string = "";

  public ngOnChanges(changes: SimpleChanges): void {
    this.roles = changes.newUser?.currentValue?.roles?.map((role: Option) => role.nombre).join(", ");
  }
}
